import { Box } from "@mui/material";
import { ReactNode } from "react";

type FadeViewTransitionProps = {
  activeKey: string;
  views: FadeViewTransitionView[];
  durationMs?: number;
  fitParent?: boolean;
};

export type FadeViewTransitionView = {
  key: string;
  children: ReactNode;
};

const viewStyle = {
  position: "absolute",
  inset: 0,
  height: "100%",
  width: "100%",
  willChange: "opacity, transform",
};

const visibleViewStyle = {
  opacity: 1,
  transform: "translateY(0) scale(1)",
  pointerEvents: "auto",
};

const hiddenViewStyle = {
  opacity: 0,
  transform: "translateY(12px) scale(0.99)",
  pointerEvents: "none",
};

export function FadeViewTransition({
  activeKey,
  views,
  durationMs = 150,
  fitParent = false,
}: FadeViewTransitionProps) {
  const containerStyle = {
    position: "relative",
    height: fitParent ? "100%" : "100vh",
    width: fitParent ? "100%" : "100vw",
    overflow: "hidden",
  };
  const transitionStyle = {
    transition: [
      `opacity ${durationMs}ms ease`,
      `transform ${durationMs}ms ease`,
    ].join(", "),
  };

  return (
    <Box sx={containerStyle}>
      {views.map((view) => {
        const isActive = view.key === activeKey;

        return (
          <Box
            key={view.key}
            sx={[
              viewStyle,
              transitionStyle,
              isActive ? visibleViewStyle : hiddenViewStyle,
              {
                zIndex: isActive ? 1 : 0,
              },
            ]}
          >
            {view.children}
          </Box>
        );
      })}
    </Box>
  );
}
